import { type ReactNode, forwardRef, useEffect } from 'react';

import { type ICheckBoxCardProps } from '@gbs-monorepo-packages/common';

import { GOOGLE_FONTS_API_URL } from '../../../../constants/Env';
import { type IFont } from '../../../../pages/EditCourse/components/FontsModal';
import { type IFontDTO } from '../../../../services/courses';
import { CheckBoxCardCustom, FontTitle } from './styles';

export interface IData extends IFontDTO {
  sourceIndex?: number;
}

export interface IFontCardProps
  extends Omit<ICheckBoxCardProps, 'children' | 'value'> {
  data: IFont;
  dataCy?: string;
  value?: string;
  children?: ReactNode;
}

export const FontCard = forwardRef<HTMLButtonElement, IFontCardProps>(
  function FontCard(
    {
      children,
      data: { family, category },
      dataCy = family,
      value = `${family}`,
      ...props
    },
    ref
  ): JSX.Element {
    useEffect(() => {
      const encodedFamily = encodeURIComponent(family);
      const id = `gbs-font-${encodedFamily}`;
      if (typeof document === 'undefined') return;
      if (document.getElementById(id)) return;

      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = `${GOOGLE_FONTS_API_URL}?family=${encodedFamily}&text=${encodedFamily}`;
      document.head.appendChild(link);
    }, [family]);

    return (
      <CheckBoxCardCustom
        {...props}
        ref={ref}
        dataCy={dataCy}
        isNotButton
        value={value}
        defaultValue={[`${family}`]}
      >
        <FontTitle
          style={{ fontFamily: `${family}, ${category}` }}
          data-cy="item-text"
        >
          {family}
        </FontTitle>
        {children}
      </CheckBoxCardCustom>
    );
  }
);
